import {
    IParagraphSuggestionsActionTypes,
    IParagraphSuggestionsReducer,
    RESET_SUGGESTIONS,
    SET_LOADING_SUGGESTIONS,
    SET_SUGGESTIONS,
    SET_SUGGESTIONS_INITIAL_LOAD_COMPLETED,
} from './ParagraphSuggestions-types';

const initialState: IParagraphSuggestionsReducer = {
    nextPageNumber: 1,
    suggestions: [],
    count: 0,
    loading: false,
    initialLoadCompleted: false,
};

const ParagraphSuggestionsReducer = (
    state = initialState,
    action: IParagraphSuggestionsActionTypes
): IParagraphSuggestionsReducer => {
    switch (action.type) {
        case RESET_SUGGESTIONS:
            return {
                ...state,
                ...initialState,
            };
        case SET_SUGGESTIONS_INITIAL_LOAD_COMPLETED:
            return {
                ...state,
                initialLoadCompleted: action.initialLoadCompleted,
            };
        case SET_LOADING_SUGGESTIONS:
            return {
                ...state,
                loading: action.loading,
            };
        case SET_SUGGESTIONS:
            return {
                ...state,
                suggestions: action.suggestions,
                count: action.count ?? state.count,
                nextPageNumber: action.nextPageNumber ?? state.nextPageNumber,
                loading: false,
            };
        default:
            return state;
    }
};

export default ParagraphSuggestionsReducer;
